import { FC } from 'react';

import { withTrackedSceneView } from '@portal/common/services/google-analytics';

import LayoutWithTopbar from '../layout/LayoutWithTopbar';

const AnonymousRoute: FC = () => <LayoutWithTopbar />;

export default withTrackedSceneView(AnonymousRoute);
